import { MessageCircle, Facebook, Instagram, Send, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function ShareMenu({ url, label = "Share your ticket link", compact = false }) {
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent(url);
  const text = encodeURIComponent(`Come ride with the I-65 Ryders! Grab your ticket: ${url}`);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const t = document.createElement("textarea");
      t.value = url; document.body.appendChild(t); t.select();
      document.execCommand("copy"); document.body.removeChild(t);
    }
    setCopied(true);
    toast.success("Link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  const links = [
    { key: "sms", label: "Text", icon: MessageCircle, href: `sms:?&body=${text}`, color: "#25c05a" },
    { key: "fb", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}`, color: "#1877f2" },
    { key: "messenger", label: "Messenger", icon: Send, href: `https://www.facebook.com/dialog/send?link=${enc}&app_id=0&redirect_uri=${enc}`, color: "#a334fa" },
    { key: "ig", label: "Instagram", icon: Instagram, onClick: copy, color: "#e1306c" },
  ];

  return (
    <div data-testid="share-menu">
      {!compact && <p className="eyebrow text-xs text-[#d4af37] mb-3">{label}</p>}
      <div className="flex flex-wrap gap-2">
        {links.map((l) => {
          const Icon = l.icon;
          const cls = "flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5";
          return l.onClick ? (
            <button key={l.key} onClick={l.onClick} className={cls} style={{ background: l.color }} data-testid={`share-${l.key}`}>
              <Icon size={16} /> {l.label}
            </button>
          ) : (
            <a key={l.key} href={l.href} target="_blank" rel="noreferrer" className={cls} style={{ background: l.color }} data-testid={`share-${l.key}`}>
              <Icon size={16} /> {l.label}
            </a>
          );
        })}
        <button onClick={copy} className="flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold btn-gold" data-testid="share-copy">
          {copied ? <Check size={16} /> : <Link2 size={16} />} {copied ? "Copied" : "Copy Link"}
        </button>
      </div>
    </div>
  );
}
